export class VersionModel {
  version = ''
  databaseVersion = ''
  lastDownloadCompanyResult = ''
  lastExternalSync = ''
  lastsynclicense = ''
  lastSyncCompanyResult = ''
}
